import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { DashboardPage } from '~/features/dashboard/dashboard-page';

function DashboardRoute(): ReactElement {
  return <DashboardPage />;
}

export const Route = createFileRoute('/_app/dashboard/')({
  component: DashboardRoute,
});
